/* eslint-disable @typescript-eslint/member-delimiter-style */
/**
 * User Reviews Api Contracts
 * User Reviews Api Contracts definitions. Join the Slack channel `#gt-connection`
 *
 * The version of the OpenAPI document: 1.20180904.10
 * Contact: DL-eBay-GT-Squads-Connection@ebay.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from './configuration';
//@ts-ignore
import { BASE_PATH, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface ApiRatingBreakdownItem
 */
export interface ApiRatingBreakdownItem {
    /**
     * Specific rating value (1-5)
     * @type {number}
     * @memberof ApiRatingBreakdownItem
     */
    rating: number;
    /**
     * number of reviews for the specific rating
     * @type {number}
     * @memberof ApiRatingBreakdownItem
     */
    number: number;
}
/**
 *
 * @export
 * @interface ApiReview
 */
export interface ApiReview {
    /**
     * review id
     * @type {number}
     * @memberof ApiReview
     */
    reviewId: number;
    /**
     * the accountId of an user who created the review
     * @type {number}
     * @memberof ApiReview
     */
    reviewerId: number;
    /**
     * the accountId of an user who is being reviewed
     * @type {number}
     * @memberof ApiReview
     */
    revieweeId: number;
    /**
     * the id of an item that was used to create an connection between reviewer and reviewee (in gumtree it\'s advertId)
     * @type {number}
     * @memberof ApiReview
     */
    itemId: number;
    /**
     * the content of the review
     * @type {string}
     * @memberof ApiReview
     */
    comment?: string;
    /**
     * Stars like rating 1-5
     * @type {number}
     * @memberof ApiReview
     */
    rating: number;
    /**
     * the item(advert) title
     * @type {string}
     * @memberof ApiReview
     */
    itemTitle: string;
    /**
     * the id of the item(advert) category
     * @type {number}
     * @memberof ApiReview
     */
    categoryId: number;
    /**
     * Review status. Supported values: LIVE, DELAYED (and maybe more later)
     * @type {string}
     * @memberof ApiReview
     */
    status: string;
    /**
     *
     * @type {string}
     * @memberof ApiReview
     */
    submittedDate: string;
    /**
     *
     * @type {Direction}
     * @memberof ApiReview
     */
    direction: Direction;
}
/**
 *
 * @export
 * @interface ApiReviewMetaAttributes
 */
export interface ApiReviewMetaAttributes {
    /**
     * advert L1 category
     * @type {number}
     * @memberof ApiReviewMetaAttributes
     */
    l1Category?: number;
    /**
     * is seller pro user?
     * @type {boolean}
     * @memberof ApiReviewMetaAttributes
     */
    proUser?: boolean;
    /**
     * the number of messages in the conversation written by seller
     * @type {number}
     * @memberof ApiReviewMetaAttributes
     */
    noOfSellerMessages?: number;
    /**
     * the number of messages in the conversation written by buyer
     * @type {number}
     * @memberof ApiReviewMetaAttributes
     */
    noOfBuyerMessages?: number;
    /**
     * the conversation id
     * @type {string}
     * @memberof ApiReviewMetaAttributes
     */
    conversationId?: string;
    /**
     * platform like - web, android, ios
     * @type {string}
     * @memberof ApiReviewMetaAttributes
     */
    platform?: string;
}
/**
 *
 * @export
 * @interface BrazeNotifyRequest
 */
export interface BrazeNotifyRequest {
    /**
     * the braze notification that need reverse reviewer and reviewee
     * @type {boolean}
     * @memberof BrazeNotifyRequest
     */
    needReverse: boolean;
    /**
     * the review direction like B2S (buyer to(review of) seller), S2B (seller to(review of) buyer)
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    direction: BrazeNotifyRequestDirectionEnum;
    /**
     * the adId that trigger review
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    adId: string;
    /**
     * the conversationId that trigger review
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    conversationId: string;
    /**
     * the userId of an user who created the review
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    reviewerUserId: string;
    /**
     * the userName of an user who created the review
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    reviewerUserName: string;
    /**
     * the userId of an user who is being reviewed
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    revieweeUserId: string;
    /**
     * the userName of an user who is being reviewed
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    revieweeUserName: string;
    /**
     * the braze notification that need delete first before update
     * @type {boolean}
     * @memberof BrazeNotifyRequest
     */
    needDelete?: boolean;
    /**
     * Stars like rating 1-5
     * @type {number}
     * @memberof BrazeNotifyRequest
     */
    rating?: number;
    /**
     * the reviewer current status
     * @type {string}
     * @memberof BrazeNotifyRequest
     */
    status: BrazeNotifyRequestStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum BrazeNotifyRequestDirectionEnum {
    B2S = 'B2S',
    S2B = 'S2B',
}
/**
 * @export
 * @enum {string}
 */
export enum BrazeNotifyRequestStatusEnum {
    OnGoing = 'onGoing',
    Completed = 'completed',
}

/**
 *
 * @export
 * @interface CanReviewResponse
 */
export interface CanReviewResponse {
    /**
     * true if the reviewer is allowed to review the reviewee owned item
     * @type {boolean}
     * @memberof CanReviewResponse
     */
    value: boolean;
}
/**
 *
 * @export
 * @interface CanReviewerReviewRequest
 */
export interface CanReviewerReviewRequest {
    /**
     *
     * @type {UniqueReviewer}
     * @memberof CanReviewerReviewRequest
     */
    reviewer: UniqueReviewer;
    /**
     *
     * @type {number}
     * @memberof CanReviewerReviewRequest
     */
    revieweeId: number;
    /**
     * the id of an item (advertId) that was used to create an connection between reviewer and reviewee
     * @type {number}
     * @memberof CanReviewerReviewRequest
     */
    itemId: number;
}
/**
 *
 * @export
 * @interface CreateReviewRequest
 */
export interface CreateReviewRequest {
    /**
     * the accountId of an user who created the review
     * @type {number}
     * @memberof CreateReviewRequest
     */
    reviewerId: number;
    /**
     * the accountId of an user who is being reviewed
     * @type {number}
     * @memberof CreateReviewRequest
     */
    revieweeId: number;
    /**
     * the id of an item that was used to create an connection between reviewer and reviewee
     * @type {number}
     * @memberof CreateReviewRequest
     */
    itemId: number;
    /**
     * the content of the review
     * @type {string}
     * @memberof CreateReviewRequest
     */
    comment?: string;
    /**
     * Start like rating 1-5
     * @type {number}
     * @memberof CreateReviewRequest
     */
    rating: number;
    /**
     * the item(advert) title
     * @type {string}
     * @memberof CreateReviewRequest
     */
    itemTitle: string;
    /**
     * the id of the item(advert) category
     * @type {number}
     * @memberof CreateReviewRequest
     */
    categoryId: number;
    /**
     * the review direction like B2S (buyer to(review of) seller), S2B (seller to(review of) buyer)
     * @type {string}
     * @memberof CreateReviewRequest
     */
    direction: CreateReviewRequestDirectionEnum;
    /**
     * the Threatmetrix device id that helps to uniquely identify a user
     * @type {string}
     * @memberof CreateReviewRequest
     */
    deviceId?: string;
    /**
     *
     * @type {ApiReviewMetaAttributes}
     * @memberof CreateReviewRequest
     */
    metaAttributes: ApiReviewMetaAttributes;
    /**
     *
     * @type {Feedback}
     * @memberof CreateReviewRequest
     */
    feedback?: Feedback;
    /**
     * the userId of an user who created the review
     * @type {string}
     * @memberof CreateReviewRequest
     */
    reviewerUserId?: string;
    /**
     * the userName of an user who created the review
     * @type {string}
     * @memberof CreateReviewRequest
     */
    reviewerUserName?: string;
    /**
     * the userId of an user who is being reviewed
     * @type {string}
     * @memberof CreateReviewRequest
     */
    revieweeUserId?: string;
    /**
     * the userName of an user who is being reviewed
     * @type {string}
     * @memberof CreateReviewRequest
     */
    revieweeUserName?: string;
    /**
     * the source that trigger review
     * @type {string}
     * @memberof CreateReviewRequest
     */
    source?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateReviewRequestDirectionEnum {
    B2S = 'B2S',
    S2B = 'S2B',
}

/**
 *
 * @export
 * @interface CreateReviewResponse
 */
export interface CreateReviewResponse {
    /**
     * Review ID
     * @type {number}
     * @memberof CreateReviewResponse
     */
    reviewId: number;
}
/**
 * the review direction like B2S (buyer to(review of) seller), S2B (seller to(review of) buyer)
 * @export
 * @enum {string}
 */
export enum Direction {
    B2S = 'B2S',
    S2B = 'S2B',
}

/**
 *
 * @export
 * @interface ErrorItem
 */
export interface ErrorItem {
    /**
     *
     * @type {string}
     * @memberof ErrorItem
     */
    code: string;
    /**
     *
     * @type {string}
     * @memberof ErrorItem
     */
    message: string;
    /**
     *
     * @type {string}
     * @memberof ErrorItem
     */
    field?: string;
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * optional unique reference for bug tracking
     * @type {string}
     * @memberof ErrorResponse
     */
    reference?: string;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    error_code?: string;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     *
     * @type {Array<ErrorItem>}
     * @memberof ErrorResponse
     */
    errors?: Array<ErrorItem>;
}
/**
 *
 * @export
 * @interface Feedback
 */
export interface Feedback {
    /**
     *
     * @type {Tags}
     * @memberof Feedback
     */
    tags?: Tags;
}
/**
 *
 * @export
 * @interface FeedbackSummary
 */
export interface FeedbackSummary {
    /**
     *
     * @type {TagsSummary}
     * @memberof FeedbackSummary
     */
    tags: TagsSummary;
}
/**
 *
 * @export
 * @interface GetReviewsResponse
 */
export interface GetReviewsResponse {
    /**
     *
     * @type {Array<ApiReview>}
     * @memberof GetReviewsResponse
     */
    reviews: Array<ApiReview>;
}
/**
 *
 * @export
 * @interface GetReviewsWithFeedbackResponse
 */
export interface GetReviewsWithFeedbackResponse {
    /**
     *
     * @type {Array<ReviewWithFeedback>}
     * @memberof GetReviewsWithFeedbackResponse
     */
    reviews: Array<ReviewWithFeedback>;
    /**
     *
     * @type {FeedbackSummary}
     * @memberof GetReviewsWithFeedbackResponse
     */
    feedbackSummary: FeedbackSummary;
}
/**
 *
 * @export
 * @interface GetSummaryRatingReceivedResponse
 */
export interface GetSummaryRatingReceivedResponse {
    /**
     * average rating
     * @type {number}
     * @memberof GetSummaryRatingReceivedResponse
     */
    averageRating: number;
    /**
     * total number of reviews received
     * @type {number}
     * @memberof GetSummaryRatingReceivedResponse
     */
    totalReceived: number;
    /**
     * break down by specific rating
     * @type {Array<ApiRatingBreakdownItem>}
     * @memberof GetSummaryRatingReceivedResponse
     */
    breakdown: Array<ApiRatingBreakdownItem>;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum NegativeTagName {
    Rude = 'Rude',
    Unhelpful = 'Unhelpful',
    Unresponsive = 'Unresponsive',
    ItemNotAsDescribed = 'Item not as described',
    CancelledOffer = 'Cancelled offer',
    DidntShowUp = "Didn't show up",
    TooMuchHaggling = 'Too much haggling',
}

/**
 *
 * @export
 * @interface NegativeTagWithCount
 */
export interface NegativeTagWithCount {
    /**
     *
     * @type {NegativeTagName}
     * @memberof NegativeTagWithCount
     */
    tagName: NegativeTagName;
    /**
     *
     * @type {number}
     * @memberof NegativeTagWithCount
     */
    count: number;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum PositiveTagName {
    Friendly = 'Friendly',
    Polite = 'Polite',
    Helpful = 'Helpful',
    SpeedyResponder = 'Speedy responder',
    ItemAsDescribed = 'Item as described',
    QuickTransaction = 'Quick transaction',
    ShowedUpOnTime = 'Showed up on time',
    FairNegotiation = 'Fair negotiation',
}

/**
 *
 * @export
 * @interface PositiveTagWithCount
 */
export interface PositiveTagWithCount {
    /**
     *
     * @type {PositiveTagName}
     * @memberof PositiveTagWithCount
     */
    tagName: PositiveTagName;
    /**
     *
     * @type {number}
     * @memberof PositiveTagWithCount
     */
    count: number;
}
/**
 *
 * @export
 * @interface PublishDelayedReviewsRequest
 */
export interface PublishDelayedReviewsRequest {
    /**
     * Id of a reviews to publish (useful if we only want to publish selected reviews).
     * @type {Array<number>}
     * @memberof PublishDelayedReviewsRequest
     */
    review_ids?: Array<number>;
    /**
     * Publish all reviews submitted before this datetime
     * @type {string}
     * @memberof PublishDelayedReviewsRequest
     */
    limit_date?: string;
}
/**
 *
 * @export
 * @interface ReviewWithFeedback
 */
export interface ReviewWithFeedback {
    /**
     * review id
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    reviewId: number;
    /**
     * the accountId of an user who created the review
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    reviewerId: number;
    /**
     * the accountId of an user who is being reviewed
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    revieweeId: number;
    /**
     * the id of an item that was used to create an connection between reviewer and reviewee (in gumtree it\'s advertId)
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    itemId: number;
    /**
     * the content of the review
     * @type {string}
     * @memberof ReviewWithFeedback
     */
    comment?: string;
    /**
     * Stars like rating 1-5
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    rating: number;
    /**
     * the item(advert) title
     * @type {string}
     * @memberof ReviewWithFeedback
     */
    itemTitle: string;
    /**
     * the id of the item(advert) category
     * @type {number}
     * @memberof ReviewWithFeedback
     */
    categoryId: number;
    /**
     * Review status. Supported values: LIVE, DELAYED (and maybe more later)
     * @type {string}
     * @memberof ReviewWithFeedback
     */
    status: string;
    /**
     *
     * @type {string}
     * @memberof ReviewWithFeedback
     */
    submittedDate: string;
    /**
     *
     * @type {Direction}
     * @memberof ReviewWithFeedback
     */
    direction: Direction;
    /**
     *
     * @type {Feedback}
     * @memberof ReviewWithFeedback
     */
    feedback?: Feedback;
}
/**
 *
 * @export
 * @interface ReviewWithFeedbackAllOf
 */
export interface ReviewWithFeedbackAllOf {
    /**
     *
     * @type {Feedback}
     * @memberof ReviewWithFeedbackAllOf
     */
    feedback?: Feedback;
}
/**
 *
 * @export
 * @interface Tags
 */
export interface Tags {
    /**
     *
     * @type {Array<PositiveTagName>}
     * @memberof Tags
     */
    positive?: Array<PositiveTagName>;
    /**
     *
     * @type {Array<NegativeTagName>}
     * @memberof Tags
     */
    negative?: Array<NegativeTagName>;
}
/**
 *
 * @export
 * @interface TagsSummary
 */
export interface TagsSummary {
    /**
     *
     * @type {Array<PositiveTagWithCount>}
     * @memberof TagsSummary
     */
    positive: Array<PositiveTagWithCount>;
    /**
     *
     * @type {Array<NegativeTagWithCount>}
     * @memberof TagsSummary
     */
    negative: Array<NegativeTagWithCount>;
}
/**
 *
 * @export
 * @interface UniqueReviewer
 */
export interface UniqueReviewer {
    /**
     * effectively the common accountId as the id of the reviewer
     * @type {number}
     * @memberof UniqueReviewer
     */
    reviewerId: number;
    /**
     * value determined by ThreatMetrix API that is meant to uniquely identify a user amongst possible different gumtree accounts
     * @type {string}
     * @memberof UniqueReviewer
     */
    deviceId?: string;
}

/**
 * BrazeInvokeApi - axios parameter creator
 * @export
 */
export const BrazeInvokeApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * notification a new braze
         * @param {BrazeNotifyRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brazeNotification: async (
            review: BrazeNotifyRequest,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'review' is not null or undefined
            if (review === null || review === undefined) {
                throw new RequiredError(
                    'review',
                    'Required parameter review was null or undefined when calling brazeNotification.'
                );
            }
            const localVarPath = `/braze/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof review !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(review !== undefined ? review : {})
                : review || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * BrazeInvokeApi - functional programming interface
 * @export
 */
export const BrazeInvokeApiFp = (configuration?: Configuration) => {
    return {
        /**
         * notification a new braze
         * @param {BrazeNotifyRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brazeNotification(
            review: BrazeNotifyRequest,
            clientId?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReviewResponse>
        > {
            const localVarAxiosArgs = await BrazeInvokeApiAxiosParamCreator(
                configuration
            ).brazeNotification(review, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * BrazeInvokeApi - factory interface
 * @export
 */
export const BrazeInvokeApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * notification a new braze
         * @param {BrazeNotifyRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brazeNotification(
            review: BrazeNotifyRequest,
            clientId?: string,
            options?: any
        ): AxiosPromise<CreateReviewResponse> {
            return BrazeInvokeApiFp(configuration)
                .brazeNotification(review, clientId, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrazeInvokeApi - object-oriented interface
 * @export
 * @class BrazeInvokeApi
 * @extends {BaseAPI}
 */
export class BrazeInvokeApi extends BaseAPI {
    /**
     * notification a new braze
     * @param {BrazeNotifyRequest} review Review to create
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrazeInvokeApi
     */
    public brazeNotification(review: BrazeNotifyRequest, clientId?: string, options?: any) {
        return BrazeInvokeApiFp(this.configuration)
            .brazeNotification(review, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ReviewsReadApi - axios parameter creator
 * @export
 */
export const ReviewsReadApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Check if there is already a record of a review for a given reviewerId, optional deviceId and itemId
         * @param {CanReviewerReviewRequest} request Holds the info. that uniquely identify a Reviewer and the itemId (advertId)
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canReviewerReview: async (
            request: CanReviewerReviewRequest,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError(
                    'request',
                    'Required parameter request was null or undefined when calling canReviewerReview.'
                );
            }
            const localVarPath = `/reviews/reviewer/can-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof request !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(request !== undefined ? request : {})
                : request || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviews matching supplied criteria and include feedback details.
         * @param {number} revieweeId reviewee id
         * @param {number} [maxReviewCount] Maximum Review count to return. Recent reviews will be returned first in descending order.
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByRevieweeIdWithFeedback: async (
            revieweeId: number,
            maxReviewCount?: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'revieweeId' is not null or undefined
            if (revieweeId === null || revieweeId === undefined) {
                throw new RequiredError(
                    'revieweeId',
                    'Required parameter revieweeId was null or undefined when calling findByRevieweeIdWithFeedback.'
                );
            }
            const localVarPath = `/reviews/reviewee/{revieweeId}/withFeedback`.replace(
                `{${'revieweeId'}}`,
                encodeURIComponent(String(revieweeId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (maxReviewCount !== undefined) {
                localVarQueryParameter.maxReviewCount = maxReviewCount;
            }

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get review by review id
         * @param {number} reviewId review id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByReviewId: async (
            reviewId: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            if (reviewId === null || reviewId === undefined) {
                throw new RequiredError(
                    'reviewId',
                    'Required parameter reviewId was null or undefined when calling findOneByReviewId.'
                );
            }
            const localVarPath = `/reviews/{reviewId}`.replace(
                `{${'reviewId'}}`,
                encodeURIComponent(String(reviewId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get review received summary for a given user
         * @param {number} revieweeId reviewee id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRatingReceivedByRevieweeId: async (
            revieweeId: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'revieweeId' is not null or undefined
            if (revieweeId === null || revieweeId === undefined) {
                throw new RequiredError(
                    'revieweeId',
                    'Required parameter revieweeId was null or undefined when calling findRatingReceivedByRevieweeId.'
                );
            }
            const localVarPath = `/reviews/users/{revieweeId}/rating-received`.replace(
                `{${'revieweeId'}}`,
                encodeURIComponent(String(revieweeId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByRevieweeId: async (
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'revieweeId' is not null or undefined
            if (revieweeId === null || revieweeId === undefined) {
                throw new RequiredError(
                    'revieweeId',
                    'Required parameter revieweeId was null or undefined when calling findReviewsByRevieweeId.'
                );
            }
            const localVarPath = `/reviews/reviewee/{revieweeId}`.replace(
                `{${'revieweeId'}}`,
                encodeURIComponent(String(revieweeId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter.offset = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter.page_size = pageSize;
            }

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviews of reviewee created by reviewer. Example: If I\'m an buyer I can use this endpoint to get all reviews I have written(I\'m reviewer) for an particular seller (reviewee)
         * @param {number} reviewerId reviewee id
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerForReviewee: async (
            reviewerId: number,
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'reviewerId' is not null or undefined
            if (reviewerId === null || reviewerId === undefined) {
                throw new RequiredError(
                    'reviewerId',
                    'Required parameter reviewerId was null or undefined when calling findReviewsByReviewerForReviewee.'
                );
            }
            // verify required parameter 'revieweeId' is not null or undefined
            if (revieweeId === null || revieweeId === undefined) {
                throw new RequiredError(
                    'revieweeId',
                    'Required parameter revieweeId was null or undefined when calling findReviewsByReviewerForReviewee.'
                );
            }
            const localVarPath = `/reviews/reviewer/{reviewerId}/reviewee/{revieweeId}`
                .replace(`{${'reviewerId'}}`, encodeURIComponent(String(reviewerId)))
                .replace(`{${'revieweeId'}}`, encodeURIComponent(String(revieweeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter.offset = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter.page_size = pageSize;
            }

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviews created by an user (reviewer)
         * @param {number} reviewerId A ID of an reviewer
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerId: async (
            reviewerId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'reviewerId' is not null or undefined
            if (reviewerId === null || reviewerId === undefined) {
                throw new RequiredError(
                    'reviewerId',
                    'Required parameter reviewerId was null or undefined when calling findReviewsByReviewerId.'
                );
            }
            const localVarPath = `/reviews/reviewer/{reviewerId}`.replace(
                `{${'reviewerId'}}`,
                encodeURIComponent(String(reviewerId))
            );
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter.offset = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter.page_size = pageSize;
            }

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} reviewerId reviewer id
         * @param {number} revieweeId reviewee id
         * @param {number} itemId item id, example: advert id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerIdAndItemId: async (
            reviewerId: number,
            revieweeId: number,
            itemId: number,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'reviewerId' is not null or undefined
            if (reviewerId === null || reviewerId === undefined) {
                throw new RequiredError(
                    'reviewerId',
                    'Required parameter reviewerId was null or undefined when calling findReviewsByReviewerIdAndItemId.'
                );
            }
            // verify required parameter 'revieweeId' is not null or undefined
            if (revieweeId === null || revieweeId === undefined) {
                throw new RequiredError(
                    'revieweeId',
                    'Required parameter revieweeId was null or undefined when calling findReviewsByReviewerIdAndItemId.'
                );
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError(
                    'itemId',
                    'Required parameter itemId was null or undefined when calling findReviewsByReviewerIdAndItemId.'
                );
            }
            const localVarPath =
                `/reviews/reviewer/{reviewerId}/reviewee/{revieweeId}/item/{itemId}`
                    .replace(`{${'reviewerId'}}`, encodeURIComponent(String(reviewerId)))
                    .replace(`{${'revieweeId'}}`, encodeURIComponent(String(revieweeId)))
                    .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ReviewsReadApi - functional programming interface
 * @export
 */
export const ReviewsReadApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Check if there is already a record of a review for a given reviewerId, optional deviceId and itemId
         * @param {CanReviewerReviewRequest} request Holds the info. that uniquely identify a Reviewer and the itemId (advertId)
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canReviewerReview(
            request: CanReviewerReviewRequest,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanReviewResponse>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).canReviewerReview(request, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get reviews matching supplied criteria and include feedback details.
         * @param {number} revieweeId reviewee id
         * @param {number} [maxReviewCount] Maximum Review count to return. Recent reviews will be returned first in descending order.
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByRevieweeIdWithFeedback(
            revieweeId: number,
            maxReviewCount?: number,
            clientId?: string,
            options?: any
        ): Promise<
            (
                axios?: AxiosInstance,
                basePath?: string
            ) => AxiosPromise<GetReviewsWithFeedbackResponse>
        > {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findByRevieweeIdWithFeedback(revieweeId, maxReviewCount, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get review by review id
         * @param {number} reviewId review id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByReviewId(
            reviewId: number,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReview>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findOneByReviewId(reviewId, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get review received summary for a given user
         * @param {number} revieweeId reviewee id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRatingReceivedByRevieweeId(
            revieweeId: number,
            clientId?: string,
            options?: any
        ): Promise<
            (
                axios?: AxiosInstance,
                basePath?: string
            ) => AxiosPromise<GetSummaryRatingReceivedResponse>
        > {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findRatingReceivedByRevieweeId(revieweeId, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReviewsByRevieweeId(
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReviewsResponse>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findReviewsByRevieweeId(revieweeId, offset, pageSize, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get reviews of reviewee created by reviewer. Example: If I\'m an buyer I can use this endpoint to get all reviews I have written(I\'m reviewer) for an particular seller (reviewee)
         * @param {number} reviewerId reviewee id
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReviewsByReviewerForReviewee(
            reviewerId: number,
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReviewsResponse>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findReviewsByReviewerForReviewee(
                reviewerId,
                revieweeId,
                offset,
                pageSize,
                clientId,
                options
            );
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get reviews created by an user (reviewer)
         * @param {number} reviewerId A ID of an reviewer
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReviewsByReviewerId(
            reviewerId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReviewsResponse>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findReviewsByReviewerId(reviewerId, offset, pageSize, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} reviewerId reviewer id
         * @param {number} revieweeId reviewee id
         * @param {number} itemId item id, example: advert id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReviewsByReviewerIdAndItemId(
            reviewerId: number,
            revieweeId: number,
            itemId: number,
            clientId?: string,
            options?: any
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReview>> {
            const localVarAxiosArgs = await ReviewsReadApiAxiosParamCreator(
                configuration
            ).findReviewsByReviewerIdAndItemId(reviewerId, revieweeId, itemId, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ReviewsReadApi - factory interface
 * @export
 */
export const ReviewsReadApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Check if there is already a record of a review for a given reviewerId, optional deviceId and itemId
         * @param {CanReviewerReviewRequest} request Holds the info. that uniquely identify a Reviewer and the itemId (advertId)
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canReviewerReview(
            request: CanReviewerReviewRequest,
            clientId?: string,
            options?: any
        ): AxiosPromise<CanReviewResponse> {
            return ReviewsReadApiFp(configuration)
                .canReviewerReview(request, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reviews matching supplied criteria and include feedback details.
         * @param {number} revieweeId reviewee id
         * @param {number} [maxReviewCount] Maximum Review count to return. Recent reviews will be returned first in descending order.
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByRevieweeIdWithFeedback(
            revieweeId: number,
            maxReviewCount?: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<GetReviewsWithFeedbackResponse> {
            return ReviewsReadApiFp(configuration)
                .findByRevieweeIdWithFeedback(revieweeId, maxReviewCount, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get review by review id
         * @param {number} reviewId review id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByReviewId(
            reviewId: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<ApiReview> {
            return ReviewsReadApiFp(configuration)
                .findOneByReviewId(reviewId, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get review received summary for a given user
         * @param {number} revieweeId reviewee id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRatingReceivedByRevieweeId(
            revieweeId: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<GetSummaryRatingReceivedResponse> {
            return ReviewsReadApiFp(configuration)
                .findRatingReceivedByRevieweeId(revieweeId, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByRevieweeId(
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<GetReviewsResponse> {
            return ReviewsReadApiFp(configuration)
                .findReviewsByRevieweeId(revieweeId, offset, pageSize, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reviews of reviewee created by reviewer. Example: If I\'m an buyer I can use this endpoint to get all reviews I have written(I\'m reviewer) for an particular seller (reviewee)
         * @param {number} reviewerId reviewee id
         * @param {number} revieweeId reviewee id
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerForReviewee(
            reviewerId: number,
            revieweeId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<GetReviewsResponse> {
            return ReviewsReadApiFp(configuration)
                .findReviewsByReviewerForReviewee(
                    reviewerId,
                    revieweeId,
                    offset,
                    pageSize,
                    clientId,
                    options
                )
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reviews created by an user (reviewer)
         * @param {number} reviewerId A ID of an reviewer
         * @param {number} [offset] offset
         * @param {number} [pageSize] page size
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerId(
            reviewerId: number,
            offset?: number,
            pageSize?: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<GetReviewsResponse> {
            return ReviewsReadApiFp(configuration)
                .findReviewsByReviewerId(reviewerId, offset, pageSize, clientId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reviews matching supplied criteria
         * @param {number} reviewerId reviewer id
         * @param {number} revieweeId reviewee id
         * @param {number} itemId item id, example: advert id
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReviewsByReviewerIdAndItemId(
            reviewerId: number,
            revieweeId: number,
            itemId: number,
            clientId?: string,
            options?: any
        ): AxiosPromise<ApiReview> {
            return ReviewsReadApiFp(configuration)
                .findReviewsByReviewerIdAndItemId(reviewerId, revieweeId, itemId, clientId, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReviewsReadApi - object-oriented interface
 * @export
 * @class ReviewsReadApi
 * @extends {BaseAPI}
 */
export class ReviewsReadApi extends BaseAPI {
    /**
     * Check if there is already a record of a review for a given reviewerId, optional deviceId and itemId
     * @param {CanReviewerReviewRequest} request Holds the info. that uniquely identify a Reviewer and the itemId (advertId)
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public canReviewerReview(request: CanReviewerReviewRequest, clientId?: string, options?: any) {
        return ReviewsReadApiFp(this.configuration)
            .canReviewerReview(request, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviews matching supplied criteria and include feedback details.
     * @param {number} revieweeId reviewee id
     * @param {number} [maxReviewCount] Maximum Review count to return. Recent reviews will be returned first in descending order.
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findByRevieweeIdWithFeedback(
        revieweeId: number,
        maxReviewCount?: number,
        clientId?: string,
        options?: any
    ) {
        return ReviewsReadApiFp(this.configuration)
            .findByRevieweeIdWithFeedback(revieweeId, maxReviewCount, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get review by review id
     * @param {number} reviewId review id
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findOneByReviewId(reviewId: number, clientId?: string, options?: any) {
        return ReviewsReadApiFp(this.configuration)
            .findOneByReviewId(reviewId, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get review received summary for a given user
     * @param {number} revieweeId reviewee id
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findRatingReceivedByRevieweeId(revieweeId: number, clientId?: string, options?: any) {
        return ReviewsReadApiFp(this.configuration)
            .findRatingReceivedByRevieweeId(revieweeId, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviews matching supplied criteria
     * @param {number} revieweeId reviewee id
     * @param {number} [offset] offset
     * @param {number} [pageSize] page size
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findReviewsByRevieweeId(
        revieweeId: number,
        offset?: number,
        pageSize?: number,
        clientId?: string,
        options?: any
    ) {
        return ReviewsReadApiFp(this.configuration)
            .findReviewsByRevieweeId(revieweeId, offset, pageSize, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviews of reviewee created by reviewer. Example: If I\'m an buyer I can use this endpoint to get all reviews I have written(I\'m reviewer) for an particular seller (reviewee)
     * @param {number} reviewerId reviewee id
     * @param {number} revieweeId reviewee id
     * @param {number} [offset] offset
     * @param {number} [pageSize] page size
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findReviewsByReviewerForReviewee(
        reviewerId: number,
        revieweeId: number,
        offset?: number,
        pageSize?: number,
        clientId?: string,
        options?: any
    ) {
        return ReviewsReadApiFp(this.configuration)
            .findReviewsByReviewerForReviewee(
                reviewerId,
                revieweeId,
                offset,
                pageSize,
                clientId,
                options
            )
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviews created by an user (reviewer)
     * @param {number} reviewerId A ID of an reviewer
     * @param {number} [offset] offset
     * @param {number} [pageSize] page size
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findReviewsByReviewerId(
        reviewerId: number,
        offset?: number,
        pageSize?: number,
        clientId?: string,
        options?: any
    ) {
        return ReviewsReadApiFp(this.configuration)
            .findReviewsByReviewerId(reviewerId, offset, pageSize, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviews matching supplied criteria
     * @param {number} reviewerId reviewer id
     * @param {number} revieweeId reviewee id
     * @param {number} itemId item id, example: advert id
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsReadApi
     */
    public findReviewsByReviewerIdAndItemId(
        reviewerId: number,
        revieweeId: number,
        itemId: number,
        clientId?: string,
        options?: any
    ) {
        return ReviewsReadApiFp(this.configuration)
            .findReviewsByReviewerIdAndItemId(reviewerId, revieweeId, itemId, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ReviewsWriteApi - axios parameter creator
 * @export
 */
export const ReviewsWriteApiAxiosParamCreator = (configuration?: Configuration) => {
    return {
        /**
         * Creates a new review
         * @param {CreateReviewRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReview: async (
            review: CreateReviewRequest,
            clientId?: string,
            options: any = {}
        ): Promise<RequestArgs> => {
            // verify required parameter 'review' is not null or undefined
            if (review === null || review === undefined) {
                throw new RequiredError(
                    'review',
                    'Required parameter review was null or undefined when calling createReview.'
                );
            }
            const localVarPath = `/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clientId !== undefined && clientId !== null) {
                localVarHeaderParameter['Client-Id'] = String(clientId);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                if (Object.prototype.hasOwnProperty.call(localVarQueryParameter, key)) {
                    queryParameters.set(key, localVarQueryParameter[key]);
                }
            }
            for (const key in options.query) {
                if (Object.prototype.hasOwnProperty.call(options.query, key)) {
                    queryParameters.set(key, options.query[key]);
                }
            }
            localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            const nonString = typeof review !== 'string';
            const needsSerialization =
                nonString && configuration && configuration.isJsonMime
                    ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                    : nonString;
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(review !== undefined ? review : {})
                : review || '';

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * ReviewsWriteApi - functional programming interface
 * @export
 */
export const ReviewsWriteApiFp = (configuration?: Configuration) => {
    return {
        /**
         * Creates a new review
         * @param {CreateReviewRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReview(
            review: CreateReviewRequest,
            clientId?: string,
            options?: any
        ): Promise<
            (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReviewResponse>
        > {
            const localVarAxiosArgs = await ReviewsWriteApiAxiosParamCreator(
                configuration
            ).createReview(review, clientId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {
                    ...localVarAxiosArgs.options,
                    url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
                };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};

/**
 * ReviewsWriteApi - factory interface
 * @export
 */
export const ReviewsWriteApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => {
    return {
        /**
         * Creates a new review
         * @param {CreateReviewRequest} review Review to create
         * @param {string} [clientId] Client id for tracking purpose
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReview(
            review: CreateReviewRequest,
            clientId?: string,
            options?: any
        ): AxiosPromise<CreateReviewResponse> {
            return ReviewsWriteApiFp(configuration)
                .createReview(review, clientId, options)
                .then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReviewsWriteApi - object-oriented interface
 * @export
 * @class ReviewsWriteApi
 * @extends {BaseAPI}
 */
export class ReviewsWriteApi extends BaseAPI {
    /**
     * Creates a new review
     * @param {CreateReviewRequest} review Review to create
     * @param {string} [clientId] Client id for tracking purpose
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsWriteApi
     */
    public createReview(review: CreateReviewRequest, clientId?: string, options?: any) {
        return ReviewsWriteApiFp(this.configuration)
            .createReview(review, clientId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
